import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import arrowLeftIcon from './arrow_left@2x.png';
import arrowRightIcon from './arrow_right@2x.png';

const TabSwitcher = createReactClass({
  propTypes: {
    onNextClick: PropTypes.func.isRequired,
    onPrevClick: PropTypes.func.isRequired,
  },

  onNextClick() {
    this.props.onNextClick();
  },

  onPrevClick() {
    this.props.onPrevClick();
  },

  render() {
    return (
      <div className="hide-for-large-up">
        <div className="m-tabs--switcher right" onClick={this.onNextClick}>
          <img className="m-tabs--right-arrow" src={arrowRightIcon} />
        </div>
        <div className="m-tabs--switcher left" onClick={this.onPrevClick}>
          <img className="m-tabs--left-arrow" src={arrowLeftIcon} />
        </div>
      </div>
    );
  },
});

export default TabSwitcher;
